import React, { useMemo } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./team.css";
import { useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { saveSelectedTeamPlayers } from "../../utils/playerSession";

const TeamList = ({ myTeams = [], players = [] ,matchDetails}) => {
  const navigate = useNavigate();

  //  Create Player Lookup Map (Optimized)
  const playerMap = useMemo(() => {
    const map = {};
    players.forEach((player) => {
      map[player.id] = player;
    });
    return map;
  }, [players]);

  if (!myTeams?.length || !myTeams[0]?.Players?.length) {
    return (
      <p className="text-center mt-3 text-muted">
        No Teams created yet.
      </p>
    );
  }

  return (
    <div className="container team-list">
      <div className="row g-4">
        {myTeams.map((team, index) => {

          //  Get Selected Players
          const selectedPlayers = team.Players
            ?.map((id) => playerMap[id])
            .filter(Boolean) || [];
          console.log("selecteeteamteamteam", team);
          saveSelectedTeamPlayers(selectedPlayers);
          //  Role Counting
          const roleCount = {
            WK: 0,
            BAT: 0,
            AR: 0,
            BOWL: 0,
          };

          selectedPlayers.forEach((player) => {
            const role = player.role?.toLowerCase() || "";
            console.log("selectedPlayers222", selectedPlayers);

            if (role.includes("wk")) {
              roleCount.WK++;
            }
            else if (role.includes("allrounder")) {
              roleCount.AR++;
            }
            else if (role.includes("bowl")) {
              roleCount.BOWL++;
            }
            else {
              roleCount.BAT++;
            }
          });

          //  Captain & Vice Captain
          const captainName =
            playerMap[team.CaptainId]?.name || "Captain";

          const viceCaptainName =
            playerMap[team.ViceCaptainId]?.name || "Vice Captain";

          const match = matchDetails || team.match || {};
          const stats = team.stats || {};

          return (
            <div key={team.Id || index} className="col-md-6">
              <div
                className="team-card position-relative"
                onClick={() => navigate(`/savedteam/${team.Id}`,{ state: { team } })}
              >
                {/* Edit Button */}
                <button
                  className="edit-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(
                      `/createteam/${team.MatchId}?edit=${team.Id}`,{ state: { team } }
                    );
                  }}
                >
                  <FaEdit />
                </button>

                {/* 🔹 Top Section */}
                <div className="team-top">
                  <div>
                    <h3>{match.teamHomeCode || "IND"}</h3>
                    <p>{stats.teamANum || 0}</p>
                  </div>

                  {/* Captain */}
                  <div className="captain-wrapper">
                    <span className="captain-badge">C</span>
                    <img
                      src="https://cdn0.iconfinder.com/data/icons/cricket-22/512/Cricket_Player.png"
                      alt="Captain"
                    />
                    <span className="captain-name">
                      {captainName}
                    </span>
                  </div>

                  {/* Vice Captain */}
                  <div className="captain-wrapper">
                    <span className="vcaptain-badge">VC</span>
                    <img
                      src="https://cdn0.iconfinder.com/data/icons/cricket-22/512/Cricket_Player.png"
                      alt="Vice Captain"
                    />
                    <span className="vcaptain-name">
                      {viceCaptainName}
                    </span>
                  </div>

                  <div>
                    <h3>{match.teamAwayCode || "AUS"}</h3>
                    <p>{stats.teamBNum || 0}</p>
                  </div>
                </div>

                {/* 🔹 Bottom Section */}
                <div className="team-bottom container">
                  <div className="row text-center">
                    <div className="col text-black">
                      WK{" "}
                      <span style={{ color: "#1a3d32f0" }}>
                        {roleCount.WK}
                      </span>
                    </div>

                    <div className="col text-black">
                      BAT{" "}
                      <span style={{ color: "#1a3d32f0" }}>
                        {roleCount.BAT}
                      </span>
                    </div>

                    <div className="col text-black">
                      AR{" "}
                      <span style={{ color: "#1a3d32f0" }}>
                        {roleCount.AR}
                      </span>
                    </div>

                    <div className="col text-black">
                      BOWL{" "}
                      <span style={{ color: "#1a3d32f0" }}>
                        {roleCount.BOWL}
                      </span>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TeamList;